import React, { Suspense, lazy, useState } from 'react';
import ErrorBoundary from '@components/ErrorBoundary';
import { Button } from '@components/ui/button';
import { RotateCw } from 'lucide-react';
import CollapsedView from './AIChat/CollapsedView';
import { panelClass, railClass } from './AIChat/shell';

const AIChat = lazy(
  () => import(/* webpackChunkName: 'ai-assistant' */ './AIChat/AIChat'),
);

/** The assistant starts loading in parallel with the page, never inside the
 * entry bundle. Keep its rail and remember early clicks while it loads. */
export function LazyAIChat({
  forceCollapse = false,
}: {
  forceCollapse?: boolean;
}) {
  const [startExpanded, setStartExpanded] = useState(false);
  return (
    <ErrorBoundary
      fallback={
        <div className={railClass(false)}>
          <div className={panelClass(true, false, true)}>
            <Button
              variant="ghost"
              size="icon"
              aria-label="Reload AI Assistant"
              title="Assistant could not load. Reload to try again."
              onClick={() => window.location.reload()}
            >
              <RotateCw className="size-4" />
            </Button>
          </div>
        </div>
      }
    >
      <Suspense
        fallback={
          <div className={railClass(false)}>
            <div
              className={panelClass(true, false, forceCollapse)}
              onClick={() => {
                if (!forceCollapse) setStartExpanded(true);
              }}
            >
              <CollapsedView
                forceCollapse={forceCollapse}
                setIsCollapse={(value) => {
                  if (
                    !forceCollapse &&
                    (typeof value === 'function' ? !value(true) : !value)
                  )
                    setStartExpanded(true);
                }}
                isLoading={startExpanded}
              />
            </div>
          </div>
        }
      >
        <AIChat forceCollapse={forceCollapse} startExpanded={startExpanded} />
      </Suspense>
    </ErrorBoundary>
  );
}
